export enum SessionStorage {
  ParticipantPosition = 'participantPosition',
  /** Set before the UE logout navigates away, read once on the next page. */
  LeftExperienceNotice = 'leftExperienceNotice',
}
